import { Box } from "@chakra-ui/layout";
import { Checkbox } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import { DocumentoForm } from "core/features/documentos/typings";
import { Control } from "react-hook-form";
import Field from "ui/components/Input/Field";
import InputFileDropzone from "ui/components/Input/InputFileDropzone";
import SelectGrupoUnidade from "ui/components/Input/SelectGrupoUnidade";
import SelectTipoDestino from "ui/components/Input/SelectTipoDestino";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import SelectDocumentoPai from "./../SelectDocumentoPai";
import { useLoading } from "./../../../GlobalLoading/index";

interface FormDocumentoProps {
  control: Control<DocumentoForm, object>;
  form: DocumentoForm;
  isEdit?: boolean;
  hideDestino?: boolean;
  mimetype?: string;
  isLoading: boolean;
}

function FormDocumento({
  control,
  form,
  isEdit = false,
  hideDestino = false,
  mimetype,
  isLoading,
}: FormDocumentoProps) {
  const { tenant } = useCurrentTenant();

  useLoading(isLoading);
  
  return (
    <>
      <Box mb={8}>
        <Field
          control={control}
          name="nome"
          label="Nome do documento"
          rules={{ required: true }}
        />
      </Box>

      {isEdit ? (
        <Box mb={8}>
          <Field
            control={control}
            name="documentoPaiId"
            label="Pasta"
            shouldUnregister
            rules={{ required: true }}
            render={({ field }) => <SelectDocumentoPai {...field} />}
          />
        </Box>
      ) : null}

      {!hideDestino ? (
        <Box as={Row} gutter={16}>
          <Box as={Col} xs={12}>
            <Field
              shouldUnregister
              control={control}
              label="Enviar para quem"
              rules={{ required: true }}
              name="tipoDestinoId"
              render={({ field }) => (
                <SelectTipoDestino
                  onChange={field.onChange}
                  value={field.value}
                  showEmail={false}
                  allowClear
                />
              )}
            />
          </Box>

          {form.tipoDestinoId &&
          form.tipoDestinoId !== TipoDestinoEnum.TodasUnidades ? (
            <Box as={Col} xs={12}>
              <Field
                shouldUnregister
                control={control}
                rules={{ required: true }}
                label={
                  form.tipoDestinoId === TipoDestinoEnum.UmGrupoUnidades
                    ? "Grupo"
                    : "Unidade"
                }
                name="destinoId"
                render={({ field, isInvalid }) =>
                  form.tipoDestinoId === TipoDestinoEnum.UmGrupoUnidades ? (
                    <SelectGrupoUnidade
                      disabled={isEdit}
                      onChange={field.onChange}
                      isInvalid={isInvalid}
                      value={field.value}
                    />
                  ) : (
                    <SelectUnidade
                      disabled={isEdit}
                      tenantId={tenant.id}
                      onChange={field.onChange}
                      isInvalid={isInvalid}
                      value={field.value}
                    />
                  )
                }
              />
            </Box>
          ) : null}
        </Box>
      ) : null}

      {!isEdit ? (
        <Box my={4}>
          <Field
            control={control}
            name="notificarMoradores"
            render={({ field, isInvalid }) => (
              <Checkbox
                isChecked={field.value}
                isInvalid={isInvalid}
                onChange={() => {
                  field.onChange(!field.value);
                }}
              >
                Notificar os moradores
              </Checkbox>
            )}
          />
        </Box>
      ) : null}

      <Box my={4}>
        <Field
          shouldUnregister
          control={control}
          label="Arquivo"
          name="file"
          rules={{ required: true }}
          render={({ field, isInvalid }) => (
            <InputFileDropzone
              onChange={field.onChange}
              isInvalid={isInvalid}
              value={field.value}
              isMultiple={false}
              accept={isEdit ? mimetype : "application/pdf,image/*"}
            />
          )}
        />
      </Box>
    </>
  );
}

export default FormDocumento;
